import { useContext, useEffect, useState } from "react";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { useHistory } from "react-router";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Loading from "../../components/Genericos/Loading/Loading";
import Modal from "../../components/Genericos/Modal/Modal";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import BuscadorConsultaMedica from "../../components/Turnos/BuscadorConsultaMedica/BuscadorConsultaMedica";
import {
  LimpiarSelectCM,
  LimpiarSelectGlobal,
  SelectUserCM,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { estudioGrupo } from "../../context/Actions/estudioGrupo/estudioGrupo";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { showModal } from "../../context/Actions/modal/modal";
import { logoutConsultaMedTurnos } from "../../context/Actions/turnos/consultaMedTurnos";
import { logoutEstudiosTurnos } from "../../context/Actions/turnos/estudioTurnos";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { PortalContext } from "../../context/Provider";
import "./ConsultaMedica.css";
import { GlobalContext } from "../../../global/context/Provider";
import { getPlatforms } from "@ionic/react";
import { motion } from "framer-motion";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { FaChevronLeft } from "react-icons/fa";
import styled from "styled-components";

const ConsultaMedica = () => {
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    estudioTurnosState,
    consultaMedTurnosState,
    modalState,
    laboGrupoState,
    laboGrupoDispatch,
    modalDispatch,
    selectDropDownDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    estudioTurnosDispatch,
    consultaMedTurnosDispatch,
    textosState,
    // presentismoState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterState, configState } =
    useContext(GlobalContext);

  const history = useHistory();

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  //repetir en las paginas para tener los datos de los grupos
  useEffect(() => {
    if (configState.config.data !== null) {
      if (estudioGrupoState.estudioGrupo.data === null) {
        estudioGrupo()(estudioGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.data === null &&
        configState.config?.data?.opcLaboratorio
      ) {
        laboGrupo()(laboGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.centros === null &&
        configState.config?.data?.opcLaboratorio
      ) {
        wsGetLaboCentros()(laboGrupoDispatch);
      }
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "CONSULTA_MEDICA"
      ) {
        logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
      }
    }
    //eslint-disable-next-line
  }, [configState.config.data]);

  const onChangeMultitabMobile = (e) => {
    // Aquí hay que hacer un dispatch
    // Para poder elegir el usuario
    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth?.data?.paciente?.codigo &&
        e.manejoTurnos
      ) {
        SelectUserCM({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch
        );
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch
        );
      } else if (e.id !== authState.auth?.data?.paciente?.codigo) {
        // Toaster que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro"
        )(modalDispatch);

        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectCM()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      }
    } else {
      LimpiarSelectCM()(selectDropDownDispatch);
      // comentado como en estudios.
      // LimpiarSelectGlobal()(selectDropDownDispatch);
    }
  };

  // ------------------------ MODAL PUBLICITARIO ------------------------------------

  useEffect(() => {
    let publicidad = textosState?.textos?.data?.publicidades;
    const view = getLocalStorage("publicidad_portal");
    if (publicidad && publicidad.length > 0 && !view) {
      showModal(
        "Turnos/Publicidad/Publicidad",
        {
          publicidad: publicidad,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  }, [
    textosState?.textos?.data?.publicidades,
    estudioGrupoState.estudioGrupo.loading,
  ]);

  // ------------------------ MODAL PUBLICITARIO ------------------------------------ 

  return (
    <>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}

      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />

      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <Loading
        dataLoading={
          estudioGrupoState.estudioGrupo.loading ||
          estudioTurnosState.estudioTurnos.loading ||
          consultaMedTurnosState.consultaMedTurnos.loading ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading &&
            "Cargando consultas médicas...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando consultas médicas...") ||
          ((estudioTurnosState.estudioTurnos.loading ||
            consultaMedTurnosState.consultaMedTurnos.loading) &&
            "Cargando...")
        }
      />
      {/* <MultitabMobile
        posicionMultitab={1}
        onChangeMultitabMobile={onChangeMultitabMobile}
        type={"CONSULTA_MEDICA"}
      /> */}

      {estudioGrupoState.estudioGrupo.data &&
        !estudioGrupoState.estudioGrupo.loading && (
          <motion.div
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
            className="ptur-bodyContainer-ConsultaMedica"
          >
            {/* <Sidebar /> */}
            <div className="ptur-consultaMedica-container">
              <VolverBtn
                type="button"
                onClick={() => history.push("/autocheckin")}
                aria-label="Volver al inicio"
              >
                <FaChevronLeft />
                <span className=" c-white rb16m">Volver</span>
              </VolverBtn>
              <TituloSaludo />
              <div className="ptur-consultaMedica-buscador">
                <div className="ptur-consultaMedica-tabs">
                  {/* <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} /> */}
                </div>
                <BuscadorConsultaMedica
                  onChangeMultitabMobile={onChangeMultitabMobile}
                />
              </div>
            </div>
          </motion.div>
        )}
    </>
  );
};

export default ConsultaMedica;

// Botón Volver a la izquierda del dropdown (visible en tablet/desktop)
const VolverBtn = styled.button`
  display: none;
  @media (min-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    padding: 0 12px;
    margin-bottom: 12px;
    border-radius: 8px;
    border: 1px solid var(--color-latex30);
    background: var(--color-latex10);
    color: var(--color-white);
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
    &:hover {
      background: var(--color-latex30);
    }
    svg {
      font-size: 16px;
      color: var(--color-white);
    }
  }
`;
